import { SurveyAnswers } from "@/contexts";
import type { PhqOption } from "@/hooks";

const PHQ_WEIGHT_MAP: Record<PhqOption, number> = {
  notAtAll: 0,
  severalDays: 1,
  moreThanHalfTheDays: 2,
  nearlyEveryDay: 3,
};

export const calculatePhqScore = ({
  phq1,
  phq2,
  phq3,
  phq4,
}: SurveyAnswers): number => {
  const phqAnswers = [phq1, phq2, phq3, phq4];

  return phqAnswers.reduce((acc, phqAnswer) => {
    if (!phqAnswer) {
      throw Error("PHQ survey answers expected");
    }

    return acc + PHQ_WEIGHT_MAP[phqAnswer];
  }, 0);
};
